import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import EditAddForm from "./edit-add-form";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import editIcon from "../../../../assets/assests/edit.png";
import Dots from "../../../../assets/assests/detail.png";
import { Tag } from "primereact/tag";
import moment from "moment";
import { exportToExcel } from "../../components/helper";
import Details from "./details-alert";
export default function AlertReceived({ globalFilter, exportCSV }) {
  const [isEdit, setIsEdit] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [res, setRes] = useState([]);
  const [rowselect, setRowselect] = useState(null);
  const [editable, setEditable] = useState();
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getAlertData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/alerts/get-all-paginated`, {
        params: {
          pageNumber,
          pageSize,
          searchTerm: debouncedSearch || "",
        },
      });
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getAlertData(pageNumber, rows);
  };

  useEffect(() => {
    if (debouncedSearch) {
      getAlertData(1, rows, debouncedSearch);
    } else {
      getAlertData(1, rows);
    }
  }, [debouncedSearch]);

  const onHide = () => {
    setShowDialog(false);
  };

  const editAction = (rowData) => {
    setEditable(true);
    setRowselect(rowData);
    setShowDialog(true);
  };

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/alerts/get-all`);
      exportToExcel(response.data.body, columnsData, "AlertData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);

  const actionTemplate = (rowData) => {
    const isActive = rowData?.IsActive;
    return (
      <div className="action-buttons flex">
         <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>
      </div>
    );
  };

  const toggleDialogMode = (editMode = false, rowData = null) => {
    setShowDialog(true);
    setIsEdit(editMode);
    setRowselect(rowData);
    if (!editMode) {
      setSelectedData(null);
    }
  };
   const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }

  const columnsData = [
    {
      field: "kioskId",
      header: "kiosk Id",
      body: (rowData) => rowData.kioskId || "--",
      frozen: true,
    },
    {
      field: "kioskName",
      header: "Kiosk Name",
      body: (rowData) => rowData.kioskName || "--",
      frozen: true,
    },

    {
      field: "roleName",
      header: "role ",
      body: (rowData) => rowData.roleName || "--",
    },
    {
      field: "assignedUserName",
      header: "assigned User ",
      body: (rowData) => rowData.assignedUserName || "--",
    },
    {
      field: "message",
      header: "message ",
      body: (rowData) => rowData.message || "--",
    },
    {
      field: "createdDate",
      header: "created Date",
      body: (rowData) =>
        rowData.createdDate
          ? moment(rowData.createdDate).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  return (
    <>
      <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Alert Received Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      <div className="">
        <Dialog
          header={
            <div className="popup-header">
              <div className="popup-header-text">
                {isEdit ? "Edit User" : "Add New User"}
              </div>
            </div>
          }
          visible={showDialog}
          onHide={onHide}
          className="dialog-size"
        >
          <EditAddForm
            rowData={rowselect}
            setShowDialog={setShowDialog}
            getAlertData={getAlertData}
            showDialog={showDialog}
            editable={editable}
            onHide={onHide}
            formData={isEdit ? selectedData : null}
            setRes={setRes}
          />
        </Dialog>

        {loading && (
          <div className="spinner-overlay">
            <Spinner />
          </div>
        )}

        <div className="card card-container">
          <DataTable
            emptyMessage="No record found."
            value={filteredList}
            className="custom-data-table"
            scrollable
            globalFilter={globalFilter}
          >
            {columnsData.map((data, index) => (
              <Column
                key={index}
                field={data.field}
                header={data.header}
                body={data.body}
                frozen={data.frozen}
              />
            ))}
          </DataTable>
          {totalRecords > 0 && (
            <PaginatorComponent
              first={first}
              rows={rows}
              totalRecords={totalRecords}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </>
  );
}
